import { PROMPT_MSG_TYPES } from 'countable@model';

export class AiPromptsUtil {
  static getFileUploadObj(prompt: PROMPT_MSG_TYPES) {
    return {
      'hasConfirmation': false,
      'inputType': prompt,
      'isDisabled': false,
      'attachedFiles': [],
      'message': this.getMessage(prompt)
    };
  }

  static getMessage(prompt: PROMPT_MSG_TYPES) {
    if (prompt === 'IS') {
      return `Sure! Please upload the required documents, and we\'ll get started on generating your Investment Schedule.`;
    }
    if (prompt === 'LAS') {
      return `Sure! Please upload the required documents, and we\'ll get started on generating your Loan Amortization Schedule.`;
    }
    if(prompt === 'RECONCILIATION') {
      return `Sure! Please upload the required documents, and we\'ll get started on generating your Reconciliation.`;
    }

  }

  static getVRInputs() {
    return {
      'matPercent': null,
      'matVal': null,
      'isDisabled': false,
      'inputType': 'VARIANCE_ANALYSIS_INPUTS'
    };
  }
}
